module.exports = "<h2>{{t 'webapp.reporting.wizard.topic_selected_results' }}</h2>\n"